import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { InputNumberMask } from '../../../../../../../../CommonComponents/OPL/Input/InputNumberMask';
import { FormFields } from '../../AccountForm.meta';

export const LongTermCapitalGainsRatio = () => {
  const formBag = useFormContext<FormFields>();

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.CapitalGainsRatio"
      render={({ field }) => (
        <InputNumberMask
          {...field}
          rightIcon="far fa-percent"
          decimalScale={2}
          allowNegative={false}
          thousandSeparator={false}
          label="Long-Term Capital Gains Ratio"
          tooltip={ADV.tooltip_callouts.Profile_Accounts_Form_Brokerage.CapitalGainsRatio.html}
        />
      )}
    />
  );
};
